import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 21,
	viewBox: "0 0 14 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14 14C14 17.866 10.866 21 7 21C3.13401 21 0 17.866 0 14C0 10.134 3.13401 0 7 0C10.866 0 14 10.134 14 14Z" })
});
export default SvgDrop;
